// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"44c3a158","498":"041f6097","703":"429078d2","787":"1a0b6ad5"}[chunkId] + ".chunk.js";
};